module.exports = __webpack_public_path__ + "static/media/more.67f1bf98.svg";